import { render, staticRenderFns } from "./GroupedTariffPage.vue?vue&type=template&id=ca321622&scoped=true&"
import script from "./GroupedTariffPage.vue?vue&type=script&lang=js&"
export * from "./GroupedTariffPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupedTariffPage.vue?vue&type=style&index=0&id=ca321622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca321622",
  null
  
)

export default component.exports